import React from 'react';
import AddActivity from '../../../components/Multi/Department-Activity/AddActivity';

const AddActivityPage = () => {

  return (
    <div>
      <AddActivity />
    </div>
  )
}

export default AddActivityPage
